import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

export const NotFoundContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20;
  color: white;
  font-size: '2em';
`;

const NotFound = () => {
  const { t } = useTranslation();
  return <NotFoundContainer>{t('error.notFound')}</NotFoundContainer>;
};

export default NotFound;
